import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { IDetalleSeguimientoPasstModel } from 'src/app/models/interfaces/passt/ISeguimientoPasstModel';
import { PasstDetalleCompletarModel } from 'src/app/models/passt/PasstDetalleCompletarModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { PasstService } from 'src/app/services/passt/passt.service';

@Component({
  selector: 'app-passt-actividad-eliminar-dialog',
  templateUrl: './passt-actividad-eliminar-dialog.component.html',
  styleUrls: ['./passt-actividad-eliminar-dialog.component.css']
})
export class PasstActividadEliminarDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PasstActividadEliminarDialogComponent>,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private passtService: PasstService,
    @Inject(MAT_DIALOG_DATA) public model: IDetalleSeguimientoPasstModel) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  } 
  
  Save(): void{
    this.confirmDialogService.open('Seguro de eliminar la actividad del programa?'); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        let eliminarModel= new PasstDetalleCompletarModel();
        eliminarModel.idPasstActividad=this.model.idPasstActividad;
        eliminarModel.comentarios=this.model.comentarios;
        //this.dialogRef.close(this.model);
        this.passtService.eliminaractividad(eliminarModel).subscribe((result: ActionResultModel) => {
          if(result.type!=eTypeResult.SUCCESS){
            this.alertDialogService.open(result.message);
          }else{
            this.dialogRef.close(this.model);
            this.alertDialogService.open('Se eliminó la actividad.');
            
          }
          
        });
      }
    },error => {
      //console.log('oops', error)
      this.alertDialogService.open(`Se produjo un error al registrar su información, por favor contactar con el administrador. Detalle: ${error.title}.`)
    });
  }

  esValido(): boolean{
    let valido:boolean=true;
    
    if(!this.model.comentarios)
      valido=false;

    return valido;
  }
}
